// extracted by mini-css-extract-plugin
export default {"overlayContainer":"NoteFinderPageOverlay_overlayContainer__GLjwH"};